<script lang="ts">
  export let color = '#D0D5DD';
  export let strokeWidth = 1.66667;
  export let width = 21;
  export let height = 20;
  export let d = 'm17.1107 5-9.16669 9.1667L3.77734 10';
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} {height} fill="none"
  ><path
    stroke={color}
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
    {d}
  /></svg
>
